function isNull(el) {
  return undefined === el || null === el;
}

export const systemTypeNames = {
  1: 'Pool System',
  2: 'Spa System',
  3: 'Swim Spa System',
};

export const systemTypeNamesFormat = formatMessage => {

  if (!isNull(formatMessage)) {
    return {
      1: formatMessage({id: 'manifold.system.title.pool'}),
      2: formatMessage({id: 'manifold.system.title.spa'}),
      3: formatMessage({id: 'manifold.system.title.swimspa'}),
    };
  }
  return systemTypeNames;
};

export const locationTypes = {
  I: 'Indoor',
  O: 'Outdoor',
};

export const locationTypesFormat = formatMessage => {

  if (!isNull(formatMessage)) {
    return {
      I: formatMessage({id: 'general.location.indoor'}),
      O: formatMessage({id: 'general.location.outdoor'}),
    };
  }
  return finishTypes;
};

export const finishTypes = {
  B: 'Pebbled',
  C: 'Colored Plaster',
  F: 'Fiberglass',
  P: 'Painted',
  S: 'Stainless Steel',
  U: 'Unprinted Vinyl',
  V: 'Printed Vinyl',
  W: 'White Plaster',
};

export const finishTypesFormat = formatMessage => {

  if (!isNull(formatMessage)) {
    return {
      B: formatMessage({id: 'general.pebbled'}),
      C: formatMessage({id: 'general.colored.plaster'}),
      F: formatMessage({id: 'general.fiberglass'}),
      P: formatMessage({id: 'general.painted'}),
      S: formatMessage({id: 'general.stainless.steel'}),
      U: formatMessage({id: 'general.unprinted.vinyl'}),
      V: formatMessage({id: 'general.printed.vinyl'}),
      W: formatMessage({id: 'general.white.plaster'}),
    };
  }
  return finishTypes;
};

export const countries = {
  US: 'US',
  CA: 'CA',
};


export const emailLanguages = [
  {lang: 'general.language.english', val: 'en-US'},
  {lang: 'general.language.french', val: 'fr-CA'},
];
